import { useMemo, useState } from 'react';

import { AppRoutes } from 'config';
import { useNavigate } from 'hooks';
import { ButtonColors } from 'types';
import { useAppSelector } from 'store';
import { isEventManagerRole } from 'store/slices/auth';
import { Flex, Dialog, Button, EventReportDialog } from 'components';

import * as Styled from './styles';
import { getButtons } from './helpers';
import { DailyReport } from './daily-report';
import { CreateReportDialogProps } from './types';

const { Questionnaire } = AppRoutes.Events;

export const CreateReportDialog = ({ event }: CreateReportDialogProps) => {
  const navigate = useNavigate();
  const [isDailyOpen, setDailyOpen] = useState(false);
  const isManager = useAppSelector(isEventManagerRole);
  const [isSummaryOpen, setSummaryOpen] = useState(false);

  const buttons = useMemo(
    () =>
      getButtons({
        event,
        isManager,
        setDailyOpen,
        setSummaryOpen,
        hasReview: !!event.questionnaires.length,
        onEventReview: () => navigate(Questionnaire),
      }),
    [event, setDailyOpen, isManager, setSummaryOpen]
  );

  return (
    <>
      <Dialog
        showCloseButton
        title="Create report"
        trigger={
          <Button text="Create report" colorType={ButtonColors.LightBlue} />
        }
      >
        {(close) => (
          <Flex gap={24} fullWidth flexDirection="column">
            {buttons.map(({ onClick, ...props }, i) => (
              <Styled.StyledButton
                {...props}
                key={i}
                fullWidth
                justifyContent="center"
                colorType={ButtonColors.LightBlue}
                onClick={(e) => {
                  close();
                  onClick?.(e);
                }}
              />
            ))}
          </Flex>
        )}
      </Dialog>

      {isDailyOpen && (
        <DailyReport
          event={event}
          opened={isDailyOpen}
          onClose={() => setDailyOpen(false)}
        />
      )}

      {isSummaryOpen && (
        <EventReportDialog
          event={event}
          opened={isSummaryOpen}
          onClose={() => setSummaryOpen(false)}
        />
      )}
    </>
  );
};
